import React, { Fragment } from "react";
import Table from "react-bootstrap/Table";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import { UserLink } from "../util/Links";
import { ShiftTableTitle } from "./ShiftTableTitle";

const ShiftTimesheetHistoryElement = ({ shift }) => {
  if (shift === null || shift === undefined) return;
  if (shift?.timesheet === null || shift?.timesheet === undefined) return;

  return (
    <Fragment>
      <ShiftTableTitle title={"Timesheet History"} />
      <Table striped hover responsive>
        <thead>
          <tr>
            <th>Status</th>
            <th>Reject Reason</th>
            <th>User</th>
            <th>Via</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {shift?.timesheetAuditTrail.map((audit) => (
            <tr key={audit?.id}>
              <td>{audit?.status}</td>
              <td>{audit?.rejectReason}</td>
              <td>{UserLink(audit?.user)}</td>
              <td>{audit?.actionedBy}</td>
              <td>{AxisDateTimeFull(audit?.created)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Fragment>
  );
};

export default ShiftTimesheetHistoryElement;
